<template>
  <ExpenseForm :expense="expense" :onSubmit="submit"></ExpenseForm>
</template>

<script>
import ExpenseForm from './Expense-Form.vue';
import { busEvent } from '../../main';

export default {
  name: 'EditExpense',
  components: {
    ExpenseForm,
  },
  created() {
    this.$store.dispatch('expenses/getExpense', this.$route.params.id);
  },
  computed: {
    expense() {
      return this.$store.state.expenses.expense;
    },
  },
  methods: {
    submit() {
      this.$store.dispatch('expenses/updateExpense', { id: this.$route.params.id, body: this.expense })
        .then(() => {
          busEvent.$emit('succesPopupCreated', 'Informatie actualizata');
          this.$router.back();
        });
    },
  },
};
</script>
